var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { AsyncRequestStatus } from "@ane/core/lib/models";
import AuthContext from "@ane/core/lib/services/MSALAuthService/MSALAuthService";
import { isEntityIdPayload, isEntityPayload, API_VERSION_PARAM, isQueryPayload } from "./types.js";
import { getUnifiedApiVersion } from "../../resources/expapiunified/ExpAPIVUnified.constants.js";
const LIST_TAG = "LIST";
const providesList = (results, tagType, includeListTag = true) => [
  ...includeListTag ? [{ type: tagType, id: LIST_TAG }] : [],
  ...(results != null ? results : []).filter((x) => !!(x == null ? void 0 : x.id)).map(({ id }) => ({ type: tagType, id }))
];
const setAuthHeader = (tokenParameters, headers) => __async(void 0, null, function* () {
  const token = yield AuthContext.getToken(tokenParameters);
  headers.set("Authorization", `Bearer ${token}`);
  return headers;
});
const rtKQueryHookToDisplayError = (rtkHook) => {
  var _a, _b, _c, _d;
  if (rtkHook.isError && rtkHook.error) {
    const apiError = (_a = rtkHook.error) == null ? void 0 : _a.data;
    return (_d = (_c = (_b = apiError.errorContext) == null ? void 0 : _b.displayError) != null ? _c : apiError.message) != null ? _d : "An error occurred";
  }
  return null;
};
const rtkQueryHookToAsyncWrapper = (rtkHook, blockOnFetch = true) => {
  const { data, error, isUninitialized, isFetching, isLoading, isError, isSuccess } = rtkHook;
  const asyncWrapper = {
    status: AsyncRequestStatus.NotStarted,
    data
  };
  const apiError = !error ? void 0 : error == null ? void 0 : error.data;
  if (apiError) {
    asyncWrapper.error = apiError.message;
    asyncWrapper.errorContext = apiError.errorContext;
  }
  if (isUninitialized) {
    asyncWrapper.status = AsyncRequestStatus.NotStarted;
  } else if (isLoading || isFetching && blockOnFetch) {
    asyncWrapper.status = AsyncRequestStatus.Pending;
  } else if (isError) {
    asyncWrapper.status = AsyncRequestStatus.Failed;
  } else if (isSuccess || isFetching) {
    asyncWrapper.status = AsyncRequestStatus.Completed;
  }
  return asyncWrapper;
};
const asyncWrapperToRtkQueryHook = (asyncWrapper) => {
  const { status, data, error, errorContext } = asyncWrapper;
  const result = {
    data: data === null ? void 0 : data,
    isUninitialized: status === AsyncRequestStatus.NotStarted,
    isLoading: status === AsyncRequestStatus.Pending,
    isFetching: status === AsyncRequestStatus.Pending,
    isError: status === AsyncRequestStatus.Failed,
    isSuccess: status === AsyncRequestStatus.Completed
  };
  if (error) {
    result.error = {
      data: {
        message: error,
        errorContext
      }
    };
  }
  return result;
};
const getResourceUrlSegment = (resource, payload, action) => {
  let baseUrl = `workspaces/${payload.workspaceId}/${resource}`;
  if (isEntityIdPayload(payload) && !!payload.id) {
    baseUrl = `${baseUrl}/${payload.id}`;
  }
  if (!!action) {
    baseUrl = `${baseUrl}:${action.replaceAll(":", "")}`;
  }
  return baseUrl;
};
const getFetchArgs = (options) => {
  const { resource, payload, action, apiVersion = getUnifiedApiVersion(), method = "GET" } = options;
  return {
    url: getResourceUrlSegment(resource, payload, action),
    body: isEntityPayload(payload) ? payload.entity : void 0,
    method,
    params: __spreadValues({
      [API_VERSION_PARAM]: apiVersion
    }, isQueryPayload(payload) ? payload.query : {})
  };
};
export {
  LIST_TAG,
  asyncWrapperToRtkQueryHook,
  getFetchArgs,
  getResourceUrlSegment,
  providesList,
  rtKQueryHookToDisplayError,
  rtkQueryHookToAsyncWrapper,
  setAuthHeader
};
//# sourceMappingURL=utils.js.map
